import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteServiceAreaOverrideRulesByFilter } from '../../../api/plan-service-area-override-rules-api'
import type {
  DeleteServiceAreaOverrideRulesByFilterRequestDto,
  DeleteServiceAreaOverrideRulesByFilterResponseDto,
} from '../../../api/dto/plan-service-area-override-rules.dto'
import { SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanServiceAreaOverride/hooks/useGetServiceAreaOverrideRules'

export function useDeleteServiceAreaOverrideRulesByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    DeleteServiceAreaOverrideRulesByFilterResponseDto,
    unknown,
    DeleteServiceAreaOverrideRulesByFilterRequestDto
  >({
    mutationFn: (params) => deleteServiceAreaOverrideRulesByFilter(params),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SERVICE_AREA_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
